import { useEffect, useRef } from 'react';

/**
 * Run `callback` on a fixed interval.
 * When `enabled` is false the interval is cleared.
 * The callback ref is kept stable so the interval is only
 * restarted when `intervalMs` or `enabled` change.
 */
export function usePolling(
  callback: () => void,
  intervalMs: number,
  enabled = true,
): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) return;

    callbackRef.current();
    const id = setInterval(() => callbackRef.current(), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);
}
